<template>
  <v-container fluid>
    <h1 class="display-inline">KPI: Project Cost Variance
      <ContextHelp help-text="This page shows the aggregate project cost variance for all jobs, broken down by service and task type.
Calculation:
 * All jobs closed in the last 365 days are loaded
 * Jobs with the 'finance exclude' flag set are excluded
 * Each job is stepped through:
   - The task name is used to match between quote tasks, job tasks, and invoice tasks. This linkage is required because only job tasks contain the service (task type) information. If a mapping is not found, the information is excluded
   - If a job has a quote, the quote is used for the billable rate otherwise the default rate is used.
   - The total cost for a task is taken by multiplying the billing rate by the actual time spent on the task
 * PCVs are calculated for each service as a percentage:
   PCV: (Actual [Invoiced] Money - Billable [Potential] Money) / Actual [Invoiced] Money
 * The total PCV is calculated by the same approach as the services, but by summing across all tasks irrespective of service.

Note: only services enabled on in the BWF settings page are used in the calculations."></ContextHelp>
    </h1>
    <div class="display-inline ml-3">
      <ActiveApiCalls/>
    </div>
    <h1></h1>
<!--    <AggregateProjectCostVariance></AggregateProjectCostVariance>-->
    <PCVGraph></PCVGraph>
  </v-container>
</template>

<script>
import PCVGraph from "@/components/capacity/PCVGraph.vue"
// import AggregateProjectCostVariance from "@/components/jobs/AggregateProjectCostVairiance.vue"
import ContextHelp from "@/components/toolkit/ContextHelp.vue";
import ActiveApiCalls from "@/components/tools/ActiveApiCalls.vue";

export default {
  name: "ReportProjectCostVariancePage",
  permissions: [
    ...PCVGraph.permissions
  ],
  components: {
    ActiveApiCalls,
    ContextHelp,
    // AggregateProjectCostVariance,
    PCVGraph
  },
  data() {
    return {
      selectedJobId: null
    }
  },
  mounted() {

  },
}

</script>

<style scoped>

</style>